
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M13.405 2.981h-2.2a2.238 2.238 0 011.855-.983h2.652a2.24 2.24 0 012.24 2.24v9.571a2.24 2.24 0 01-2.24 2.24H13.06a2.24 2.24 0 01-2.067-1.374h2.412V12.79H10.82v-.565h2.585V10.34H10.82v-.566h2.585V7.886H10.82V7.32h2.585V5.433H10.82v-.567h2.585zm3.477 0H13.94v1.887h2.942zM13.94 5.434h2.942V7.32H13.94zm2.942 2.452H13.94v1.886h2.942zm-2.942 2.453h2.942v1.885H13.94zm2.942 2.45H13.94v1.886h2.942zM10.375 2.548A2.24 2.24 0 007.737.344L1.874 1.397A2.24 2.24 0 00.032 3.602V14.34a2.24 2.24 0 001.828 2.202l5.863 1.098a2.24 2.24 0 002.652-2.202zM3.011 9.035a.308.308 0 10.502.356l1.772-2.51 1.767 2.506a.318.318 0 10.519-.368L5.69 6.381l1.802-2.51a.31.31 0 10-.505-.36L5.308 5.89 3.616 3.51a.314.314 0 10-.512.365L4.903 6.39z","clip-rule":"evenodd"}})])
          )
        }
      }
    